import Store from 'Store/.';
import { Dispatch } from 'redux';
import { v4 } from 'uuid';
import Api from 'Helpers/Api';

import { 
  EventsAction, 
  setIsFetchingAllEvents, 
  setEvents, 
  setFilteredEvents,
  setFetchAllFailed,
  setSearchedEvents,
  setIsFetchingFilteredEvents,
  setFetchFilteredFailed,
} from 'Pages/EventsPage/Redux/actions';
import moment from 'moment';

export const fetchAllEvents = () => {
  return async (dispatch: Dispatch<EventsAction>): Promise<void> => {
    const { isFetchingAllEvents, events } = Store.getState().events;

    if (isFetchingAllEvents || events && events.length > 0) {
      return null;
    }

    dispatch(setIsFetchingAllEvents());

    try {
      const response = await Api.get('EventOverviews');
      const newEvents: Julius.Website.EventOverviewViewModel[] = await response.json();
      
      newEvents.map((e) => {
        e.firstDate = moment(e.firstDate).toDate();
        e.lastDate = moment(e.lastDate).toDate();
        e.key = v4();
      });

      dispatch(setEvents(newEvents));
    } catch (e) {
      dispatch(setFetchAllFailed());
    }
  };
};

export const fetchFilteredEvents = () => {
  return async (dispatch: Dispatch<EventsAction>): Promise<void> => {
    const { isFetchingFilteredEvents, filter } = Store.getState().events;
    const { firstDate, lastDate, city } = filter;

    if (isFetchingFilteredEvents || !firstDate && !lastDate && !city) {
      return null;
    }

    dispatch(setIsFetchingFilteredEvents());

    const cityParam = city ? city : '';
    const firstDateParam = firstDate ? firstDate.toUTCString() : '';
    const lastDateParam = lastDate ? lastDate.toUTCString() : '';
    const queryParams = `city=${cityParam}&startDate=${firstDateParam}&stopDate=${lastDateParam}`

    try {
      const response = await Api.get('EventOverviews', queryParams);
      const newEvents: Julius.Website.EventOverviewViewModel[] = await response.json();
      
      newEvents.map((e) => {
        e.firstDate = moment(e.firstDate).toDate();
        e.lastDate = moment(e.lastDate).toDate();
        e.key = v4();
      });

      dispatch(setFilteredEvents(newEvents));
    } catch (e) {
      dispatch(setFetchFilteredFailed());
    }
  };
};

export const fetchSearchedEvents = (searchQuery: string) => {
  return async (dispatch: Dispatch<EventsAction>): Promise<void> => {
    dispatch(setIsFetchingFilteredEvents());

    try {
      const response = await Api.get('SearchEventOverviews', `arg=${ searchQuery }`);
      const newEvents: Julius.Website.EventOverviewViewModel[] = await response.json();

      newEvents.map((e) => {
        e.firstDate = moment(e.firstDate).toDate();
        e.lastDate = moment(e.firstDate).toDate();
        e.key = v4();
      });

      dispatch(setSearchedEvents(newEvents));
    } catch (e) {
      dispatch(setFetchFilteredFailed());
    }
  }
};


// WEBPACK FOOTER //
// ./src/pages/EventsPage/Redux/thunks.tsx